export default __webpack_public_path__ + "static/media/team.551e43d7.png";